export default __webpack_public_path__ + "static/media/Available1.cbb0cdcb.svg";